<template>
    <div class="reporting-charts" v-if="isDesktopView">
        <div class="reporting-charts__summary">
            <ChartsSummary v-for="(item, index) in chartsSummary" :key="index" :infoRef="`ref-${index}`">
                <template #title><span v-html="item.title"></span></template>
                <template #tooltip><span v-html="item.tooltip"></span></template>
                <template #amount>{{ item.amount }}</template>
            </ChartsSummary>
        </div>
        <div class="reporting-charts__container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import ChartsSummary from 'components/user/organizationreport/charts/ChartsSummary'

    export default {
        name: 'reporting-charts',
        components: {
            ChartsSummary
        },
        props: {
            chartsSummary: Array
        }
    }
</script>

<style lang="scss" scoped>
    .reporting-charts {
        padding: 10px;
        margin: 0 0 40px;

        &__summary {
            display: flex;
            gap: 10px;
            margin: 0 0 10px;
        }

        &__container {
            display: flex;
            justify-content: space-between;
            gap: 10px;
        }
    }
</style>
